const apiData: any = [
  {
    title: 'Rate and Transit time API',
    description:
      'Get accurate shipping costs instantly. This API calculates prices based on origin, destination, weight, and shipment type (domestic, international, or export), helping businesses make informed decisions fast.',
    firstIcon: 'mage:calculator',
  },
  {
    title: 'Track Shipment API',
    description:
      'Our Track Shipment API makes it easy to keep your customers updated with real-time tracking from pickup to delivery. No more manually checking with carriers—the API automatically fetches live updates.',
    firstIcon: 'gg:track',
  },
  {
    title: 'Export Booking API',
    description:
      'Simplify export operations by automating shipment bookings. This API handles cargo details, pickup scheduling, and documentation needs for smooth exports.',
    firstIcon: 'lucide:plane-takeoff',
  },
  {
    title: 'International Booking API',
    description:
      'Handle international logistics with ease. This API lets you create cross-border shipments, manage customs details, and book freight without manual processes.',
    firstIcon: 'lucide:plane-landing',
  },
  {
    title: 'Domestic Booking API',
    description:
      'Easily book domestic shipments using our API. Automate shipment creation, generate booking references, and get updates in real-time—all through a seamless integration.',
    firstIcon: 'tabler:truck-delivery',
  },
  {
    title: 'Stats Dashboard',
    description:
      'Access a real-time feed of all your bookings with relevant statuses and stats. Ideal for integrating QC Express data into your internal systems or admin dashboards.',
    firstIcon: 'oui:stats',
  },
]

export default apiData
